export default "__VITE_ASSET__CDA6pE90__"